import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-123" data-mp="2lzhgzrni1l58">
      <div className="mx-auto max-w-6xl" data-id="element-124" data-mp="2h427td0fsdf5">
        <SectionHeading id="inside-heading" eyebrow="See What's Inside" title={<>
              Don't Just Read About a Technique. <Accent data-id="element-126" data-mp="236ne3w35hjhd">Teach It Visually.</Accent>
            </>} body="Nail Educator Ready™ combines technical explanations with visual teaching resources designed to help students see the difference between correct and incorrect technique." data-id="element-125" data-mp="2d3s0nx0wrgyp" />

        <div className="mt-12" data-id="element-127" data-mp="1u81vy21lc6h4">
          <InsidePagesCarousel data-id="element-128" data-mp="3slbl1hsz2980" />
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-129" data-mp="3sl1vtwfr463d">
          This isn't a collection of generic nail ebooks. It's teaching material designed to be used
          in <Accent data-id="element-130" data-mp="28km6gs79qdsn">real nail classes.</Accent>
        </p>
      </div>
    </section>;
}